import VueRamUtils from "vue-ram-utils";

const axios_token = VueRamUtils.axios_token;
// import VueReport from "@/views/VueReport.vue";

export default {
  load_menu: (context) => {
    return axios_token
      .get("menu/")
      .then((response) => response.data)
      .then(function (data) {
        console.info("load_menu", data);
        // data = data.map(el => {
        //     el.component = VueReport
        //     return el
        // })
        context.commit("set_menudata", data);
        return data;
      })
      .catch((reason) => {
        console.info("load_menu catch", reason);
        return [];
      })
      .catch(axios_token.centralerror(null));
  },
  test_permission: (menu) => {
    console.info("test_permission", menu);
    if (menu.meta.require) {
      return true;
    }
    return true;
  },
};
